<template>
    <div
        class="rounded-md border border-divider p-3"
        data-spec-class="card_price"
    >
        <div class="mb-1 text-xs font-medium tracking-wide text-tertiary uppercase">
            <div class="flex items-center">
                <div class="flex-1">
                    <slot name="title">{{ title }}</slot>
                </div>
                <BaseTooltipHelp v-if="tooltip">
                    <span class="text-sm normal-case">
                        {{ tooltip }}
                    </span>
                </BaseTooltipHelp>
            </div>
        </div>
        <div
            v-if="price !== undefined"
            class="text-lg font-semibold text-primary"
        >
            <slot name="price">{{ formattedPrice }}</slot>
        </div>
        <div
            v-if="description !== undefined"
            class="text-xs text-muted"
        >
            <slot name="description">{{ description }}</slot>
        </div>
        <slot />
    </div>
</template>

<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseTooltipHelp from './BaseTooltipHelp.vue';

interface Props {
    title: string;
    price?: number;
    description?: string;
    tooltip?: string;
}

const props = withDefaults(defineProps<Props>(), {
    price: undefined,
    description: undefined,
    tooltip: undefined,
});

const { n } = useI18n();

const formattedPrice = computed(() => {
    return n(props.price ?? 0, 'currency');
});
</script>
